import React from 'react'
import i18next from 'i18next'

const OverlayLoader = ({ noTextDisplay, textDisplay = i18next.t('common.loadingLabel', 'Loading'), size = 30 }) => (
    <div className="sb-overlay">
        <span className="sb-spinner" style={{ width: size + 'px', height: size + 'px' }} />
        {!noTextDisplay && <span className="sb-overlay-label">{textDisplay}</span>}
    </div>
)

export default OverlayLoader
